<script>
    /**
     * zeluslugi.ru
     * @author      delphinpro <delphinpro@gmail.com>
     * @copyright   copyright © 2018 delphinpro
     * @license     licensed under the MIT license
     */
    import CalcTooltip from './CalcTooltip';

    export default {
        name: "calc-checkbox-control",

        components: {
            CalcTooltip,
        },

        model: {
            prop : 'checked',
            event: 'change',
        },

        props: {
            title   : {type: String, default: 'Untitled'},
            tooltip: {type: [String, Boolean], default: false},
            checked : Boolean,
            disabled: Boolean,
        },

        data: () => ({}),

        methods: {
            uniqueId() {
                return `calc-checkbox-control-${this._uid}`;
            },
        },
    };
</script>

<template>
  <div class="calc__group">
    <div class="calc__control calc__control_checkbox">
      <div class="checkbox" :class="{disabled:disabled}">
        <input class="checkbox__element"
               type="checkbox"
               :checked="checked"
               :name="uniqueId()"
               :id="uniqueId()"
               :disabled="disabled"
               @change="$emit('change', $event.target.checked)"
        >
        <label class="checkbox__indicator" :for="uniqueId()"></label>
        <label class="checkbox__label calc__form-label" :for="uniqueId()">{{title}}</label>
        <calc-tooltip
            v-if="tooltip"
            :content="tooltip"
        ></calc-tooltip>
      </div>
    </div>
  </div><!-- // .calc__group -->
</template>
